// extracted by css-extract-rspack-plugin
export default {"cls1":"TranslationModal-cls1_QWQ","cls2":"TranslationModal-cls2_mYG TranslationModal-cls1_QWQ"};